import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files
import translationIT from './locales/it.json';
import translationEN from './locales/en.json';
import translationFR from './locales/fr.json';
import translationDE from './locales/de.json';
import translationES from './locales/es.json';
import translationPT from './locales/pt.json';
import translationNL from './locales/nl.json';
import translationPL from './locales/pl.json';
import translationRU from './locales/ru.json';
import translationZH from './locales/zh.json';
import translationJA from './locales/ja.json';
import translationAR from './locales/ar.json';

const resources = {
  it: { translation: translationIT },
  en: { translation: translationEN },
  fr: { translation: translationFR },
  de: { translation: translationDE },
  es: { translation: translationES },
  pt: { translation: translationPT },
  nl: { translation: translationNL },
  pl: { translation: translationPL },
  ru: { translation: translationRU },
  zh: { translation: translationZH },
  ja: { translation: translationJA },
  ar: { translation: translationAR },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('selectedLanguage') || 'it', // default language
    fallbackLng: 'it',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
